import React from "react";
import { SFAvatar, SFUseStyled, SFIcons } from "@sf-core";
import { useSelector } from "react-redux";

const { styled } = SFUseStyled();

const BackgroundColor = styled("div")(({ theme }) => ({
  background: theme.palette.green300.main,
  borderRadius: "50%",
  height: 158,
  padding: theme.spacing(0.5),
  position: "relative",
}));

const SFAvatarStyled = styled(SFAvatar)(({ sx }) => ({
  width: 150,
  height: 150,
  fontSize: 50,
}));

const AvatarIcon = styled("div")(({ theme }) => ({
  background: theme.palette.green300.main,
  borderRadius: "50%",
  position: "absolute",
  top: "5%",
  right: "5%",
  color: theme.palette.grey550.main,
  padding: theme.spacing(0.5),
  paddingBottom: theme.spacing(0),
}));

const UserProfileAvatar = ({ complete = false}) => {
  const userAvatar = useSelector((state) => state.session.avatar);

  return (
    <>
      {complete ? (
        <BackgroundColor>
          <SFAvatarStyled src={userAvatar} />
          <AvatarIcon>
            <SFIcons.SFCheckIcon />
          </AvatarIcon>
        </BackgroundColor>
      ) : (
        <SFAvatarStyled src={userAvatar} />
      )}
    </>
  );
};

export default UserProfileAvatar;
